import { render, staticRenderFns } from "./PsiSidebarNavigation.vue?vue&type=template&id=08cfa341&scoped=true&"
import script from "./PsiSidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./PsiSidebarNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfa341",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VNavigationDrawer})
